/** Provides a reactive "current time" state that updates at a specified interval for UI timing requirements. */
import { useState, useEffect } from 'react';
import { MS_PER_MINUTE } from '@/config/constants';

const useCurrentTime = (updateInterval = MS_PER_MINUTE) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, updateInterval);

    return () => clearInterval(intervalId);
  }, [updateInterval]);

  return currentTime;
};

export default useCurrentTime;
